import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';
import { Status } from '../SkoreExportModal';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../../../../contexts/ModalContext';

type FooterProps = {
  id: string;
  onClear: () => void;
  onSubmit: () => void;
  status: Status;
};

function ExportFooter({ id, onClear, onSubmit, status }: FooterProps) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  return (
    <Dialog.Footer
      buttonGroupPropsLeft={{
        'aria-label': undefined,
        role: undefined,
        children: (
          <Button onClick={onClear} prominence="neutral" key="cancel">
            {t('ACTIONS.CLEAR_SELECTION')}
          </Button>
        ),
      }}
      buttonGroupPropsRight={{
        'aria-label': undefined,
        role: undefined,
        children: (
          <>
            <Button prominence="neutral" onClick={() => closeModal(id)} key="cancel">
              {t('ACTIONS.CANCEL')}
            </Button>
            <Button
              prominence="success"
              key="submit"
              onClick={onSubmit}
              busy={status === 'active'}
              tooltip={
                status === 'active'
                  ? t('PAGES.RESULTS.MODALS.SMARTSCHOOL_SKORE_EXPORT.TOOLTIPS.EXPORT_IN_PROGRESS')
                  : undefined
              }
            >
              {t('ACTIONS.CONFIRM')}
            </Button>
          </>
        ),
      }}
    />
  );
}

export default ExportFooter;
